import {
  Flex,
  List,
  Paper,
  Title,
  Text,
  Anchor,
  Timeline,
  Loader,
  Grid,
} from "@mantine/core";

import { FormattedMessage } from "react-intl";
import { useUpdateCustomerPOAData } from "../../../hooks/ui/customerPOADataStore";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import { useGetBookingStatus } from "../../../hooks/api";
import { useEffect, useState } from "react";

export default function CustomerSummary() {
  const { customerPOAData } = useUpdateCustomerPOAData();
  const [isQueryEnabled, setIsQueryEnabled] = useState(true);
  const { data, isSuccess, isError } = useGetBookingStatus({
    bookingId: customerPOAData.booking.bookingId,
    enabled: isQueryEnabled,
    credentials: customerPOAData.credentials,
  });

  useEffect(() => {
    if (data?.status === "confirmed") {
      setIsQueryEnabled(false);
    }
  }, [data?.status]);

  return (
    <Flex justify="center" align="center" mt={"2rem"} px={"xl"}>
      <Flex direction="column" maw={672} w={"100%"}>
        <Title order={2} mb="1rem" ff="var(--wallet-font-family-subjecttivity)">
          Tack {customerPOAData.name}!
        </Title>
        <Text mb={"lg"}>
          Nu har vi registrerat din fullmakt och ser över ditt pensionssparande.
          Vi har också skickat en bekräftelse till din mail.
        </Text>

        <Paper
          p={"lg"}
          radius={"lg"}
          mb={"xl"}
          bg={"var(--wallet-color-sambla-green-shade-100)"}
        >
          {data?.status === "pending" && (
            <Flex justify={"center"}>
              <Loader />
            </Flex>
          )}
          {isError && (
            <Flex>
              <Text>
                Vi kommer att ringa dig vid den tidpunkt som överenskommits med
                din rådgivare.
              </Text>
            </Flex>
          )}
          {isSuccess && data?.status === "confirmed" && (
            <>
              <Title
                c={"var(--wallet-color-sambla-green-shade-700)"}
                order={4}
                mb={"lg"}
                ff={"var(--wallet-font-family-subjecttivity)"}
              >
                Vi ringer dig {new Date(data.startsAt).toDateString()} klockan{" "}
                {new Date(data.startsAt).toLocaleTimeString()}
              </Title>
              <Text mb={"lg"}>
                Din rådgivare ({data.advisorName}) kommer att gå igenom din
                pension tillsammans med dig och ge råd kring hur du kan
                förbättra ditt sparande. För att underlätta rådgivningen ser
                gärna att du har tillgång till en dator under samtalet.
              </Text>
              <Text>
                Du kan effektivisera mötet genom att komplettera din profil och
                svara på ett par korta frågor Det tar inte mer än 2 minuter!{" "}
              </Text>
            </>
          )}
        </Paper>

        <Paper p={"xl"} radius={"lg"} mb={"xl"}>
          <Title
            order={4}
            mb={"1rem"}
            ff={"var(--wallet-font-family-subjecttivity)"}
          >
            <FormattedMessage
              id="customerSummary.nextStepsCard.title"
              defaultMessage="What happens now?"
            />
          </Title>
          <Timeline
            active={4}
            bulletSize={28}
            color={"var(--wallet-color-sambla-red-shade-600)"}
          >
            <Timeline.Item bullet={1}>
              <Title order={5}>Rådgivningssamtal</Title>
              <Text c="dimmed" size="sm">
                Vi ringer upp dig för en kostnadsfritt rådgivningssamtal där vi
                analyserar och tar fram personliga råd för att förbättra din
                pension.
              </Text>
            </Timeline.Item>
            <Timeline.Item bullet={2}>
              <Title order={5}>Förbättra ditt sparande</Title>
              <Text c="dimmed" size="sm">
                För att förbättra ditt sparande kan du bland annat bli erbjuden
                att sänka dina kostnader genom att flytta dina försäkringar.
              </Text>
            </Timeline.Item>
            <Timeline.Item bullet={3}>
              <Title order={5}>Se din pensionsöversikt</Title>
              <Text c="dimmed" size="sm">
                När din rådgivning är klar kommer du att få tillgång till din
                pensionsöversikt där du kan se och följa utvecklingen av hela
                din pension. Vi finns här för dig ända fram till dagen då du går
                i pension!
              </Text>
            </Timeline.Item>
          </Timeline>
        </Paper>

        <Paper p={"xl"} radius={"lg"} mb={"xl"}>
          <Title
            order={4}
            mb={"lg"}
            ff={"var(--wallet-font-family-subjecttivity)"}
          >
            <FormattedMessage
              id="customerSummary.contactCard.title"
              defaultMessage=""
            />
          </Title>
          <Text mb={"2rem"}>
            <FormattedMessage
              id="customerSummary.contactCard.paragraph"
              defaultMessage="Do you have questions?"
            />
          </Text>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Paper p={"lg"} withBorder radius={"24px"}>
                <PhoneIcon
                  height="48px"
                  color={"var(--wallet-color-sambla-red-shade-600)"}
                />

                <Anchor
                  href="tel:0104248918"
                  display="block"
                  mb={"lg"}
                  mt={"lg"}
                >
                  <strong>010 - 424 89 18</strong>
                </Anchor>
                <List listStyleType="none">
                  <List.Item>Mån 09-19</List.Item>
                  <List.Item>Tis - Tor 09-18</List.Item>
                  <List.Item>Fre 09-17</List.Item>
                  <List.Item>Lör - Sön 12-16</List.Item>
                </List>
              </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Paper p={"lg"} withBorder radius={"24px"}>
                <EnvelopeIcon
                  height="48px"
                  color={"var(--wallet-color-sambla-red-shade-600)"}
                />

                <Anchor
                  href="mailto:kundtjanst@samblapension.se"
                  display="block"
                  mb={"lg"}
                  mt={"lg"}
                >
                  <strong>kundtjanst@samblapension.se</strong>
                </Anchor>
                <Text>Vi svarar så fort vi kan! </Text>
                <Text>&nbsp;</Text>
                <Text>&nbsp;</Text>
              </Paper>
            </Grid.Col>
          </Grid>
        </Paper>
      </Flex>
    </Flex>
  );
}
